module.exports = __webpack_public_path__ + "static/media/img1-5.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/biosense/diff/img1-5.png
// module id = 2192
// module chunks = 3